// extracted by mini-css-extract-plugin
export default {"header":"GettingStarted_header__yCZde","gsInfoCard":"GettingStarted_gsInfoCard__yd703"};